module.exports = "/images/tl.svg?39f4d515b71982313a821f9bacfb7d7e";